module.exports = __webpack_public_path__ + "media/images/favicon_green-30c0c1c64997479dcf20991448b29e65.ico";